import { appApiFormDataHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const POST_IMPORT_GHOST = 'POST_IMPORT_GHOST'
export const importGhostApi = apiCall(
  POST_IMPORT_GHOST,
  ({
    siteId,
    file,
    ghostSiteUrl,
    downloadImages = true,
  }: {
    siteId: string
    file: File
    ghostSiteUrl?: string
    downloadImages?: boolean
  }) => {
    const formData = new FormData()
    formData.append('file', file)
    if (ghostSiteUrl) {
      formData.append('ghostSiteUrl', ghostSiteUrl)
    }
    formData.append('downloadImages', String(downloadImages))

    return {
      endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/import`),
      method: 'POST',
      body: formData,
      headers: appApiFormDataHeaders(),
    }
  },
)
